import React from 'react';
import axios from 'axios';
import { Navbar as BootstrapNavbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BsShieldCheck, BsBoxArrowRight, BsGear } from 'react-icons/bs';

const Navbar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await axios.post('/auth/logout');
    } finally {
      delete axios.defaults.headers.common['X-CSRF-Token'];
      navigate('/login', { replace: true });
    }
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <BootstrapNavbar bg="dark" variant="dark" expand="lg" className="shadow-sm fixed-top">
      <Container fluid className="px-3 px-lg-4">
        <BootstrapNavbar.Brand as={Link} to="/dashboard" className="d-flex align-items-center">
          <img
            src="/bot-logo.webp"
            alt="Logo du bot Patate"
            width="32"
            height="32"
            className="me-2 rounded-circle"
          />
          Tableau de bord Patate
        </BootstrapNavbar.Brand>
        <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/parametres"
                className={`d-flex align-items-center ${isActive('/parametres') ? 'active' : ''}`}
              >
                <BsGear className="me-1" />
                Paramètres
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link 
                as={Link} 
                to="/dashboard"
                className={`d-flex align-items-center ${isActive('/dashboard') ? 'active' : ''}`}
              >
                Accueil
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link 
                as={Link} 
                to="/sanctions"
                className={`d-flex align-items-center ${isActive('/sanctions') ? 'active' : ''}`}
              >
                <BsShieldCheck className="me-1" />
                Sanctions
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                as="button"
                onClick={logout}
                className="d-flex align-items-center text-danger"
              >
                <BsBoxArrowRight className="me-1" />
                Se déconnecter
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;
